import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CriminalService } from 'src/app/decision-grid/Services/criminal.service';
import { CriminalModel, DecisionEnum } from 'src/app/decision-grid/Models/criminal-model';
import { CriminalRecord } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { ScreeningAdditionalData } from 'src/app/models/screeningInvite';
import { Subscribable, Subscription } from 'rxjs';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';

@Component({
  selector: 'app-decision-grid-settings-read',
  templateUrl: './decision-grid-settings-read.component.html',
  styleUrls: ['./decision-grid-settings-read.component.less']
})
export class DecisionGridSettingsReadComponent implements OnInit,OnDestroy {

  public lastKey : any = {
    key : 'crimeSubCategoryFriendlyName',
    ascending : true
  };

  @Input() pkg : ScreeningAdditionalData;
  public settingSearch : string;
  crimSub$: Subscription;
  
  public get felonies() : CriminalModel[] {
    let models :CriminalModel[] = []
    if(this.crim.snapshot){
      this.crim.snapshot.crimesAgainstPersons.felonies.forEach(crm => models.push(crm));
      this.crim.snapshot.crimesAgainstProperty.felonies.forEach(crm => models.push(crm));
      this.crim.snapshot.crimesAgainstSociety.felonies.forEach(crm => models.push(crm));
    }
    if(this.settingSearch){
      models = models.filter(mdl=>{ 
        return mdl.crimeSubCategoryFriendlyName.toLowerCase().indexOf(this.settingSearch) > -1
      });
    }
    return this.appData.sortByKey(models,this.lastKey.key,this.lastKey.ascending);
  }

  public get misdees() : CriminalModel[] {
    let models :CriminalModel[] = []
    if(this.crim.snapshot){
      this.crim.snapshot.crimesAgainstPersons.misdemeanors.forEach(crm => models.push(crm));
      this.crim.snapshot.crimesAgainstProperty.misdemeanors.forEach(crm => models.push(crm));
      this.crim.snapshot.crimesAgainstSociety.misdemeanors.forEach(crm => models.push(crm));
    }
    if(this.settingSearch){
      models =  models.filter(mdl=>{ return mdl.crimeSubCategoryFriendlyName.toLowerCase().indexOf(this.settingSearch) !== -1});
    }
    return this.appData.sortByKey(models,this.lastKey.key,this.lastKey.ascending);;
  }

  public constructor(public crim : CriminalService, public appData : ApplicantDataService){}
  ngOnDestroy(): void {
    if(this.crimSub$) this.crimSub$.unsubscribe();
  }

  sort(key : string){
    if(this.lastKey.key == key){
      this.lastKey.ascending = !this.lastKey.ascending;
    }else{
      this.lastKey.key = key;
      this.lastKey.ascending = false;
    }
  }

  ngOnInit(): void {
    this.crimSub$ = this.crim.getCrimes(this.pkg.clientId).subscribe();
  }
}
